import PropTypes from "prop-types"
import React, { Component } from "react"
import { confirmAlert } from "react-confirm-alert"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { t } from "../../i18next"
import DiscardDamageCaseIcon from "../../images/icons/discard_damage_case-56.png"
import RemSendIcon from "../../images/icons/rem_send-124.png"
import RemTodoIcon from "../../images/icons/rem_todo-124.png"
import { BackNavigator, PageHeader } from "../common"
import * as actions from "./redux/actions"
import { DamageCaseIdShape, DamageCaseShape } from "./redux/shapes"
import LhoHeaderText from "../common/LhoHeaderText"

export class DamageCasePageHeader extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    authToken: PropTypes.string.isRequired,
    caseId: DamageCaseIdShape.isRequired,
    currentCase: DamageCaseShape.isRequired,
  }

  confirmDiscardCase = () =>
    this.confirm({
      title: t("damageCase.discardCase.title"),
      message: t("damageCase.discardCase.message"),
      onYes: this.discardCase,
    })

  confirmRemTodo = () =>
    this.confirm({
      title: t("damageCase.remTodo.title"),
      message: t("damageCase.remTodo.message"),
      onYes: () => this.submitCase({ forceManualProcessing: true }),
    })

  confirmRemSend = () =>
    this.confirm({
      title: t("damageCase.remSend.title"),
      message: t("damageCase.remSend.message"),
      onYes: () => this.submitCase({ forceManualProcessing: false }),
    })

  confirm = ({ title, message, onYes }) => {
    confirmAlert({
      title,
      message,
      buttons: [{ label: t("common.yes"), onClick: onYes }, { label: t("common.no") }],
    })
  }

  discardCase = () => {
    this.props.actions.discardCase(this.props.caseId)
  }

  submitCase = ({ forceManualProcessing }) => {
    const { caseId, currentCase, authToken } = this.props
    this.props.actions.submitCase(caseId, currentCase, authToken, { forceManualProcessing })
  }

  render() {
    const { lhoRef } = this.props.currentCase

    return (
      <PageHeader className="damage-case-page-header">
        <BackNavigator url={`/lho/${lhoRef}`} />
        <div className="header-text">
          {t("damageCase.titlePrefix")} <LhoHeaderText lhoRef={lhoRef} />
        </div>
        <div className="spacer" />
        <div className="damage-case-actions">
          <img
            className="action icon icon-discard_damage_case"
            title={t("damageCase.discardCase.title")}
            alt=""
            src={DiscardDamageCaseIcon}
            onClick={this.confirmDiscardCase}
          />
          <img
            className="action icon icon-rem_todo"
            title={t("damageCase.remTodo.title")}
            alt=""
            src={RemTodoIcon}
            onClick={this.confirmRemTodo}
          />
          <img
            className="action icon icon-rem_send"
            title={t("damageCase.remSend.title")}
            alt=""
            src={RemSendIcon}
            onClick={this.confirmRemSend}
          />
        </div>
      </PageHeader>
    )
  }
}

/* istanbul ignore next */
function mapStateToProps(state, ownProps) {
  return {
    authToken: state.auth.authToken,
    currentCase: state.damageCase.unsentCases[ownProps.caseId],
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DamageCasePageHeader)



// WEBPACK FOOTER //
// ./src/features/damage-case/DamageCasePageHeader.js